import { Component } from '@angular/core';

@Component({
  selector: 'app-cards4-examples-24',
  templateUrl: './cards4-examples-24.component.html'
})
export class Cards4Examples24Component {}
